import { takeLatest } from 'redux-saga/effects';
import {
  getPerfReviewItemListSuccess, getPerfReviewItemListFail, 
  getPerfReviewItemDetailsSuccess, getPerfReviewItemDetailsFail, 
  getMonthlyPerfReviewItemsSuccess, getMonthlyPerfReviewItemsFail
} from './performanceReviewItemState';
import createCrudService from '../../services/crudservice';
import { 
  doCrudCall, SAVING_MSG, UPDATING_MSG, DELETING_MSG, LOADING_MSG,
  createRecordSuccess, updateRecordSuccess, deleteRecordSuccess
} from '../../utils/crudSagaHelper';

const crudService = createCrudService('api/v1/workforce/performance-review-items');
const redirectData = { route:'/console/performance-review-items', mode:'list', recordId:0 };
const modelName = 'Performance Review Items';
const modelId = 'pri_id';

function* getPerfReviewItemList(data) {
  yield doCrudCall(
    () => crudService.getList(data.payload),
    getPerfReviewItemListSuccess,
    getPerfReviewItemListFail,
    null,
    null,
    LOADING_MSG
  );
}

function* getPerfReviewItemDetails(data) {
  yield doCrudCall(
    () => crudService.getDetails(data.payload),
    getPerfReviewItemDetailsSuccess,
    getPerfReviewItemDetailsFail,
    null,
    null,
    LOADING_MSG
  );
}

function* doPerfReviewItemCreate(data) {
  yield doCrudCall(
    () => crudService.doCreate(data.payload),
    getPerfReviewItemDetailsSuccess,
    getPerfReviewItemDetailsFail,
    createRecordSuccess(modelName),
    { ...redirectData, mode:'reload' },
    SAVING_MSG
  );
}

function* doPerfReviewItemUpdate(data) {
  yield doCrudCall(
    () => crudService.doUpdate(data.payload[modelId], data.payload),
    getPerfReviewItemDetailsSuccess,
    getPerfReviewItemDetailsFail,
    updateRecordSuccess(modelName),
    { ...redirectData, mode:'reload' },
    UPDATING_MSG
  );
}

function* doPerfReviewItemDelete(data) {
  yield doCrudCall(
    () => crudService.doDelete(data.payload.recordId),
    getPerfReviewItemDetailsSuccess,
    getPerfReviewItemDetailsFail,
    deleteRecordSuccess(modelName),
    { ...redirectData, mode:data.payload.mode },
    DELETING_MSG
  );
}

function* getMonthlyPerfReviewItems(data){
  yield doCrudCall(
    () => crudService.getList(data.payload),
    getMonthlyPerfReviewItemsSuccess,
    getMonthlyPerfReviewItemsFail,
    null,
    null,
    LOADING_MSG
  );
}

function* PerfReviewSaga() {
  yield takeLatest('performanceReviewItem/getPerfReviewItemList', getPerfReviewItemList);
  yield takeLatest('performanceReviewItem/getPerfReviewItemDetails', getPerfReviewItemDetails);
  yield takeLatest('performanceReviewItem/doPerfReviewItemCreate', doPerfReviewItemCreate);
  yield takeLatest('performanceReviewItem/doPerfReviewItemUpdate', doPerfReviewItemUpdate);
  yield takeLatest('performanceReviewItem/doPerfReviewItemDelete', doPerfReviewItemDelete);
  yield takeLatest('performanceReviewItem/getMonthlyPerfReviewItems', getMonthlyPerfReviewItems);
}

export default PerfReviewSaga;
